module.exports = __webpack_public_path__ + "img/avatar.49b7ea71.png";